import ConfirmationModal from 'legacy/app/components/modal/ConfirmationModal';

export const ExpiredTrialModal = ({
	show,
	confirmAction,
}: {
	show: boolean;
	confirmAction: () => void;
}) => (
	<ConfirmationModal
		title=""
		okButtonClassName="!tw-w-20 !tw-m-auto"
		confirmAction={confirmAction}
		okBtnStyle="primary"
		hideCancel
		show={show}
	>
		<div className="tw-flex tw-flex-col tw-gap-4">
			<p className="tw-text-base">
				Thank you for exploring Design Manager during the Free Trial period.
			</p>
			<p className="tw-text-base">Ready to continue?</p>
			<p className="tw-text-base">
				Please reach out to us at
				<span className="tw-mx-1">
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="mailto:sales@designmanager.com"
					>
						sales@designmanager.com
					</a>
				</span>
				and we will set up your account.
			</p>
		</div>
	</ConfirmationModal>
);
ExpiredTrialModal.displayName = 'ExpiredTrialModal';
